<template>
    <form-container :header="translate('uetsInbox.uetsAccounts')" v-on:save="checkFields()" :disabled="loading">
        <div v-if="!waiting" class="row">
            <div class="col-6">
                <div class="form-group row">
                    <label class="col-form-label col-sm-4">{{ translate('externalSigner.name') }}:</label>
                    <div class="col-sm-8">
                        <input @input="checkInput('Name',$event)" v-model="data.Name" name="Name" v-on:blur="handleBlur"
                            type="text" class="form-control" required/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-form-label col-sm-4">API Key:</label>
                    <div class="col-sm-8">
                        <password v-model="data.uetsDetails.ApiKey" :disabled="!isOnPrem" v-on:blur="handleBlur" name="ApiKey"
                            id="uetsDetails.ApiKey" class="form-control" @change="$forceUpdate()" required/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-form-label col-sm-4">{{ translate('incomingChannel.requestRate') }}:</label>
                    <div class="col-sm-8">
                        <input v-model="data.uetsDetails.RequestRate" :disabled="!isOnPrem" name="RequestFrequency"
                            v-on:blur="handleBlur" type="number" class="form-control" required/>
                    </div>
                </div>
                <div class="form-group row" v-if="this.uetsLoading && !isOnPrem">
                    <div class="alert alert-info">
                        {{ translate('processingMessages.uetsInfoLoading') }}
                    </div>
                </div>

                <div class="form-group row" v-else-if="(data.uetsDetails.RequestRate == null) && !isOnPrem">
                    <div class="alert alert-danger">
                        {{ translate('warnings.uetsWarning') }}
                    </div>
                </div>
                <div class="form-group row" v-else-if="(data.uetsDetails.RequestRate != null) && !isOnPrem">
                    <div class="alert alert-success">
                        {{ translate('messages.uetsSuccess') }}
                    </div>
                </div>

                <div class="form-group row" v-else-if="!isOnPrem">
                    <div class="alert alert-info">
                        {{ translate('errors.uetsInfoCantAccessed') }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-form-label col-sm-4">
                        <input type="checkbox" id="isActiveCheck" v-model="data.IsActive"/>
                        {{ translate('targetSystemImport.active') }}
                    </label>

                </div>
            </div>
            <div class="col-6">
                <h5>{{ translate('uetsInbox.uetsAccountManagers') }}</h5>
                <table class="table table-borderless table-sm">
                    <thead>
                        <tr>
                            <th>{{ translate('login.user') }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="u in data.UetsUsers" :key="u.UserId">
                            <td >
                                <select-user :user-list="userList" :requiredAuth="['Uets']"
                                    v-model="u.UserId" required></select-user>
                            </td>
                            <td class="remove" @click="removeUser(u)" :title="translate('remove')" style="max-width: 45px;">
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="2" class="text-right">
                                <button type="button" class="btn btn-secondary btn-sm" @click="addUser()">{{
                                    translate('uetsInbox.addUetsAccountManager') }}</button>
                            </td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <div v-else>
            Yükleniyor...
        </div>
        <template v-slot:footer>
            <div class="row">
                <div class="col">
                    <button type="button" accesskey="g" v-on:click="goBack" class="btn btn-outline-primary">{{
                        translate('goBack') }}</button>
                </div>
                <div class="col text-right">
                    <button accesskey="k" type="submit" class="btn btn-success">{{ translate('save') }}</button>
                </div>
            </div>
        </template>
    </form-container>
</template>

<script>
import formMixin from '../formMixin.js';
import formContainer from '../components/FormContainer.vue'
import password from '@/components/Password.vue'
import selectUser from '../components/SelectUser.vue'

import axios from 'axios'
export default {
    mixins: [formMixin],
    components: {
        formContainer,
        password,
        selectUser
    },
    created() {
        this.getUsers({ predicate: "IsActive= true" })
            .then(x => {
                this.userList = x.Result;
            }).catch(x => {
                console.log("Kullanıcı listesi yüklenemedi:", x);
            });
        
        this.getData(this.$route.params.id).then( () => {
            console.log(this.data)
            if(this.data.uetsDetails == null){
                this.data.uetsDetails = this.uetsTemplate;
                this.data.IsActive = true
            }else{
                this.data.uetsDetails.ApiKey = ""
            }
            this.getUetsInfo()
            this.waiting = false
          
        })
    },
    data() {
        return {
            loading: false,
            waiting: true,
            modelName: 'UetsProvider',
            data: {
                uetsDetails:{
                    ApiKey: null,
                    RequestRate: 0,
                    Id: null
                },
            },
            uetsLoading: false,
            userList: null,
            uetsTemplate: {
                ApiKey: null,
                RequestRate: 0,
            },
        }
    },
    methods: {
        checkFields(){
            localStorage.removeItem('UetsProvider')
            if(this.data.UetsUsers.length == 0){
                alert(this.translate('errors.uetsManagersCantEmpty'))
            }else{
                this.save()
            }
        },
        removeUser(user) {
            this.data.UetsUsers = this.data.UetsUsers.filter(x => x != user);
        },
        addUser() {
            this.data.UetsUsers.push({});
        },
        getUetsInfo() {
            this.uetsLoading = true
            if (!window.settings.isOnPrem) {
                axios.get('/account/getuetsinfo').then(x => {
                    this.data.uetsDetails.Id = x.data.Id
                    this.data.uetsDetails.RequestRate = x.data.RequestRate
                    this.uetsLoading = false
                }).catch(() => {
                    this.uetsLoading = false
                })
            }
        },
        handleBlur() {
            this.validate();
        },
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data, value, editedText)
            } else {
                this.$set(this.data, value, event.target.value)
            }
        },
    }
}
</script>